import * as React from 'react'

type Props = {
 backgroundColor: string
}

export const LargeSection: React.FC<Props> = ({ backgroundColor, children }) => {

    return (
        <div style={{
            display: 'flex',
            minHeight: 600,
            backgroundColor,
            flexDirection: 'column',
            padding: '20px 20px',
        }}>
            {children}
        </div>

    )
}
